module.exports = __webpack_public_path__ + "static/media/csun_logo.1919db5e.png";